import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Biller } from "model";
/**
* @class Reminder
* @classdesc Class definition for record type from model
* @param {Class} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.reminders[0];
* const reminder = new Reminder(record);
* @property {number} _id - The id of the reminder
* @property {Biller} _biller - Biller for the reminder.
* @property {BCMSDate} _dueDate - The due date of the reminder.
* @property {bcmsCurrency} _amount - The amount of the reminder.
* @property {String} _billReceivedFrequency - The frequency of the reminder.
* @property {Number} _daysToRemindMeInAdvanced - The days in advanced number of the reminder.
* @property {BOOLEAN} _notificationDue - The is due notification of the reminder
* @property {BOOLEAN} _notificationSent - The is sent notification of the reminder
* @property {BOOLEAN} _notificationNotPaid - The is not paid notification of the reminder
*/
export default class Reminder extends BCMSRecord{
    _id;   
    _biller;
    _typicalDueDate;
    _dueDate;
    _amount;
    _billReceivedFrequency;
    _daysToRemindMeInAdvanced;
    _notificationDue;
    _notificationSent;
    _notificationNotPaid;

    constructor (record){
      super(record);      
    }
  }

Reminder.define({
    "recordType":"reminders",
    "recordIDProp":"reminderID",
    "className" : "Reminder",
    "recordProperties":[
      /** 
     * @name id
     * @instance
     * @property get {Number} - gets name of reminder
     * @property set {Number} - sets the name of the reminder
     * @memberof Reminder 
     */
        BCMSRecordProperty.mapToNumber("id","_id","reminderID"),
      /** 
     * @name biller
     * @instance
     * @property get {Biller} - gets biller of the reminder
     * @property set {Biller} - sets the biller of the reminder
     * @memberof Reminder 
     */ 
        BCMSRecordProperty.mapToClass("biller","_biller", () => Biller, "reminderBiller"),
    /** 
     * @name typicalDueDate
     * @instance
     * @property get {BCMSDate} - gets the typical due date of the reminder
     * @property set {BCMSDate} - sets the typical due date of the reminder
     * @memberof Reminder 
     */
        BCMSRecordProperty.mapToDate("typicalDueDate","_typicalDueDate","reminderTypicalDueDate"),     
      /** 
     * @name dueDate
     * @instance
     * @property get {BCMSDate} - gets the due date of the reminder
     * @property set {BCMSDate} - sets the due date of the reminder
     * @memberof Reminder 
     */
        BCMSRecordProperty.mapToDate("dueDate","_dueDate","reminderDueDate"),      
     /** 
     * @name amount
     * @instance
     * @property get {bcmsCurrency} - gets the amount of the reminder
     * @property set {bcmsCurrency} - sets the amount of the reminder
     * @memberof Reminder 
     */ 
        BCMSRecordProperty.mapToCurrency("amount","_amount","reminderAmount"),
      /** 
     * @name billReceivedFrequency
     * @instance
     * @property get {String} - gets the frequency of the reminder
     * @property set {String} - sets the frequency of the reminder
     * @memberof Reminder 
     */
        BCMSRecordProperty.mapToString("billReceivedFrequency","_billReceivedFrequency","reminderBillReceivedFrequency"),
      /** 
     * @name daysToRemindMeInAdvanced
     * @instance
     * @property get {Number} - gets the days in advanced number of the reminder
     * @property set {Number} - sets the days in advanced number of the reminder
     * @memberof Reminder 
     */
        BCMSRecordProperty.mapToNumber("daysToRemindMeInAdvanced","_daysToRemindMeInAdvanced","reminderDaysToRemindMeInAdvance"),

    /**
     * @name notificationDue
     * @instance
     * @property get {BOOLEAN} - gets the notificationDue of the reminder
     * @property set {BOOLEAN} - sets the notificationDue of the reminder
     * @memberof Reminder
     */
        BCMSRecordProperty.mapToBoolean("notificationDue", "_notificationDue", "reminderNotificationDue"),

    /**
     * @name notificationSent
     * @instance
     * @property get {BOOLEAN} - gets the notificationSent of the reminder
     * @property set {BOOLEAN} - sets the notificationSent of the reminder
     * @memberof Reminder
     */
        BCMSRecordProperty.mapToBoolean("notificationSent", "_notificationSent", "reminderNotificationSent"),

    /**
     * @name notificationNotPaid
     * @instance
     * @property get {BOOLEAN} - gets the notificationNotPaid of the reminder
     * @property set {BOOLEAN} - sets the notificationNotPaid of the reminder
     * @memberof Reminder
     */
        BCMSRecordProperty.mapToBoolean("notificationNotPaid", "_notificationNotPaid", "reminderNotificationNotPaid")
    ]
})